module.exports = __webpack_public_path__ + "static/img/y10.f679e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y10.jpg
// module id = xZzw
// module chunks = 1